import React, { FC, useContext, Suspense, lazy } from 'react';
import { BrowserRouter, Switch, Route } from 'react-router-dom';
import { LangContext } from './context/lang';
import './css/app.scss';

const Startpage = lazy(() => import('./pages/Startpage'));
const Page404 = lazy(() => import('./pages/404'));
const PoemPage = lazy(() => import('./pages/Poem'));
const BioPage = lazy(() => import('./pages/Bio'));
const ExhibitionsPage = lazy(() => import('./pages/Exhibitions'));
const ContactPage = lazy(() => import('./pages/Contact'));
const ImprintPage = lazy(() => import('./pages/Imprint'));

const App: FC = () => {
    const { dispatch: { translate } } = useContext(LangContext);
  
    return (
        <BrowserRouter basename="/">
            <Suspense fallback={<div />}>
                <Switch>
                <Route path="/" exact><Startpage translate={translate} /></Route>
                <Route path="/poem"><PoemPage translate={translate} /></Route>
                <Route path="/bio"><BioPage translate={translate} /></Route>
                <Route path="/exhibitions"><ExhibitionsPage translate={translate} /></Route>
                <Route path="/contact"><ContactPage translate={translate} /></Route>
                <Route path="/imprint"><ImprintPage translate={translate} /></Route>
                <Route path="*"><Page404 translate={translate} /></Route>
                </Switch>
            </Suspense>
        </BrowserRouter>
    );
}

export default App;
